import { render, staticRenderFns } from "./InviteSomeone.vue?vue&type=template&id=4df479aa&scoped=true&"
import script from "./InviteSomeone.vue?vue&type=script&lang=js&"
export * from "./InviteSomeone.vue?vue&type=script&lang=js&"
import style0 from "./InviteSomeone.vue?vue&type=style&index=0&id=4df479aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df479aa",
  null
  
)

export default component.exports